<template>
  <el-dialog :visible.sync="visible" :title="modelTitle" width="800px" @close="closeDialog" append-to-body>
    <el-form :model="formData" :rules="rules" ref="formDataRef" label-width="130px" class="form-data">
      <el-form-item label="回款编号" prop="collectionNo">
        <el-input v-model="formData.collectionNo" disabled placeholder="根据编号规则自动生成"></el-input>
      </el-form-item>
      <el-form-item label="客户名称" prop="customerName">
        <el-input v-model="formData.customerName" disabled></el-input>
      </el-form-item>
      <el-form-item label="合同编号" prop="contractNo">
        <el-input v-model="formData.contractNo" disabled></el-input>
      </el-form-item>
      <el-form-item label="期数" prop="collectionPeriod">
        <el-input placeholder="请选择期数" v-model="formData.collectionPeriod" disabled>
          <el-button slot="append" @click="showSelectPlan">选择</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="回款日期" prop="collectionDate">
        <el-date-picker v-model="formData.collectionDate" clearable type="date" value-format="yyyy-MM-dd" placeholder="请选择回款日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="回款金额" prop="collectionAmount">
        <el-input v-model="formData.collectionAmount" placeholder="请输入回款金额" maxLength="15" clearable></el-input>
      </el-form-item>
      <el-form-item label="回款方式" prop="collectionModeId">
        <el-select class="type" v-model="formData.collectionModeId" clearable placeholder="请选择回款方式">
          <el-option v-for="item in receiptTypeOptions" :key="item.id" :label="item.description" :value="item.id"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark" class="full-width">
        <el-input v-model="formData.remark" rows="2" type="textarea" placeholder="请输入备注" maxLength="500" clearable></el-input>
      </el-form-item>
      <el-form-item label="附件" class="full-width">
        <upload-file-list :attachList="formData.attachList"></upload-file-list>
      </el-form-item>
      <el-form-item class="full-width" label="审批流程">
        <wf-create ref="wfCreate" :content="formData" v-if="visible" :defId="formData.defId" :insId="formData.insId" processGroup="2" />
      </el-form-item>
      <el-form-item class="full-width btn-wrap">
        <el-button type="primary" @click="savePay">保存</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="planVisible" title="选择期数" width="700px" append-to-body>
      <new-table ref="planTableRef" :data="planData" :columns="planColumns" :pages="planPages"></new-table>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { ContractApis, DictionaryApis } from "@/apis";
import { DictionaryKey } from "@/utils/enum";
import { Modal } from "@maidi/common";
import UploadFileList from "@/views/components/upload-file-list.vue";
import WfCreate from "@/views/work-flow/instance/create";
import NewTable from "@/components/new-table";
import { CommonService } from "@/service/common";

export default {
  name: "new-receipt-record",
  mounted() {},
  data() {
    return {
      visible: false,
      formData: {
        id: "",
        contractId: "", // 合同序号
        contractNo: "", // 合同编号
        collectionNo: "", // 回款编号l
        customerId: "", // 客户Id
        customerName: "", // 客户名称
        contractPlanId: "", // 回款计划序号
        collectionPeriod: "", // 回款期数
        collectionDate: "", // 回款日期
        collectionAmount: "", // 回款金额
        collectionModeId: "", // 回款方式序号
        collectionModeName: "", // 回款方式名称
        remark: "", // 备注
        attachList: [], // 备注
      },
      receiptTypeOptions: [],
      modelTitle: "",
      // 计划表
      planVisible: false,
      planData: [],
      planColumns: [
        { label: "期数", prop: "collectionPeriod" },
        { label: "计划回款金额", prop: "planAmount" },
        { label: "计划回款日期", prop: "planDate", width: "140" },
        { label: "计划回款方式", prop: "collectionModeName", width: "110" },
        {
          label: "操作",
          width: "60",
          render: (h, { row }) => {
            return (
              <el-button type="text" onClick={() => this.selectPlan(row)}>
                选择
              </el-button>
            );
          },
        },
      ],
      planPages: {
        props: {
          pageSize: 20,
          currentPage: 1,
          total: 0,
        },
        on: {
          currentChange: this.pagePlanChange,
          sizeChange: this.sizePlanChange,
        },
      },
      rules: {
        collectionDate: [{ required: true, message: "请选择回款日期", trigger: "change" }],
        collectionAmount: [
          {
            required: true,
            trigger: "change",
            validator: (rule, value, callback) => {
              if (value > this.formData.contractAmount) callback(new Error("回款金额不能大于合同金额"));
              CommonService.validatorAmount(value, callback, "请输入正确的回款金额");
            },
          },
        ],
      },
      isEdit: false,
    };
  },
  methods: {
    show(row) {
      for (const key in this.formData) {
        this.formData[key] = row[key] || "";
      }
      this.isEdit = !!this.formData.id;
      this.modelTitle = this.isEdit ? "编辑回款" : "新建回款";
      this.formData.attachList = [];
      if (this.isEdit) {
        ContractApis.getRecordAttachList(row.id).then((res) => {
          this.formData.attachList = res;
        });
      }
      DictionaryApis.getDictValueByKey(DictionaryKey.ReceiptType).then((res) => {
        this.receiptTypeOptions = res;
      });
      this.visible = true;
    },
    showSelectPlan() {
      this.getPlanData();
      this.planVisible = true;
    },
    // 选择期数
    selectPlan(row) {
      this.formData.contractPlanId = row.id; // 计划id
      this.formData.collectionPeriod = row.collectionPeriod; // 期数名称
      if (!this.isEdit) {
        this.formData.collectionDate = row.planDate; //回款日期
        this.formData.collectionAmount = row.planAmount; //回款金额
        this.formData.collectionModeId = row.collectionModeId; //回款方式序号
        this.formData.collectionModeName = row.collectionModeName; //回款方式名称
      }
      this.planVisible = false;
    },
    getPlanData() {
      ContractApis.getReceiptPlans(this.formData.contractId).then((res) => {
        res.data.forEach((i) => {
          i.planDate = i.planDate && i.planDate.slice(0, 11);
        });
        this.planData = res.data;
        this.planPages.props.total = res.dataCount;
      });
    },
    pagePlanChange(p) {
      this.pages.props.currentPage = p;
      this.getPlanData();
    },
    sizePlanChange(size) {
      this.pages.props.pageSize = size;
      this.pagePlanChange(1);
    },
    async savePay() {
      await this.$refs.formDataRef.validate();
      // 手动填写的时候，需要找到名字
      if (this.formData.collectionModeId && !this.formData.collectionModeName) {
        const collection = this.receiptTypeOptions.find((i) => i.id === this.formData.collectionModeId);
        this.formData.collectionModeName = collection ? collection.description : "";
      }
      if (this.formData.contractPlanId && !this.formData.collectionPeriod) {
        const plan = this.planData.find((i) => i.id === this.formData.contractPlanId);
        this.formData.collectionPeriod = plan ? plan.collectionPeriod : "";
      }
      if (this.formData.id) {
        await ContractApis.editReceiptRecord(this.formData);
      } else {
        // this.formData.attachList
        this.formData.id = await ContractApis.addReceiptRecord(this.formData);
      }
      this.$refs.wfCreate.submit(this.formData.id);
      this.$emit("save", this.formData);
      this.visible = false;
    },
    closeDialog() {
      this.$refs.formDataRef.resetFields();
      for (const key in this.formData) {
        this.formData[key] = "";
      }
      this.formData.attachList = [];
      this.visible = false;
    },
  },
  components: { Modal, NewTable, WfCreate, UploadFileList },
};
</script>
<style lang="scss">
.modal-wrapper.layer-mask.tree-selector.user-selector {
  z-index: 4000 !important;
}
</style>
